const historicalComparison = {
  en: {
    historicalPage: {
      title: "Historical Trend Comparison",
      subtitle: "Compare party performance across election cycles",
      refresh: "Refresh",
      electionType: "Election Type",
      councilElections: "Council Elections",
      senatorialElections: "Senatorial Elections",
      selectYears: "Select Years to Compare",
      performanceComparison: "Party Performance Comparison",
      councilsWon: "Councils Won",
      seatsWon: "Seats Won",
      yearResults: "{{year}} Results",
      councilsCount: "{{count}} councils",
      regionsCount: "{{count}}/10 regions",
      regionalAnalysis: "Regional Voting Pattern Analysis",
      selectRegion: "Select Region",
      chooseRegion: "Choose a region",
      councilElectionsIn: "Council Elections in {{region}}",
      councilsWithResults: "{{count}} councils with results",
      senatorialWinner: "Senatorial Winner",
      fetchComparisonError: "Failed to fetch comparison data",
      fetchRegionalError: "Failed to fetch regional analysis",
      regions: {
        "Adamawa": "Adamawa",
        "Centre": "Centre",
        "East": "East",
        "Far North": "Far North",
        "Littoral": "Littoral",
        "North": "North",
        "North-West": "North-West",
        "South": "South",
        "South-West": "South-West",
        "West": "West"
      }
    }
  },
  fr: {
    historicalPage: {
      title: "Comparaison des tendances historiques",
      subtitle: "Comparez la performance des partis d'un cycle électoral à l'autre",
      refresh: "Actualiser",
      electionType: "Type d'élection",
      councilElections: "Élections municipales",
      senatorialElections: "Élections sénatoriales",
      selectYears: "Sélectionnez les années à comparer",
      performanceComparison: "Comparaison de la performance des partis",
      councilsWon: "Communes remportées",
      seatsWon: "Sièges remportés",
      yearResults: "Résultats {{year}}",
      councilsCount: "{{count}} communes",
      regionsCount: "{{count}}/10 régions",
      regionalAnalysis: "Analyse des comportements de vote régionaux",
      selectRegion: "Sélectionnez une région",
      chooseRegion: "Choisissez une région",
      councilElectionsIn: "Élections municipales : {{region}}",
      councilsWithResults: "{{count}} communes avec résultats",
      senatorialWinner: "Vainqueur sénatorial",
      fetchComparisonError: "Échec du chargement des données de comparaison",
      fetchRegionalError: "Échec du chargement de l'analyse régionale",
      regions: {
        "Adamawa": "Adamaoua",
        "Centre": "Centre",
        "East": "Est",
        "Far North": "Extrême-Nord",
        "Littoral": "Littoral",
        "North": "Nord",
        "North-West": "Nord-Ouest",
        "South": "Sud",
        "South-West": "Sud-Ouest",
        "West": "Ouest"
      }
    }
  }
};

export default historicalComparison;
